import { Button, CardMedia, Stack, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import companyService from "../../services/companyService";

const AdminBranding = () => {
	
	let [ logo, setLogo ] = useState(companyService.selectedCompany.logo);
	
	useEffect(() => {
		companyService.onSelectCompany(() => {
			setLogo(companyService.selectedCompany.logo);
		});
	}, []);
	
	const handleFileChange = async (event) => {
		const fileReader = new FileReader();
		const file = event.target.files[0];
		
		fileReader.addEventListener("load", async (fileEvent) => {
			const image = new Image();
			image.src = fileEvent.target.result;
			image.onload = async () => {
				const newWidth = 219;
				const newHeight = image.height * (newWidth / image.width);
				
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				
				canvas.width = newWidth;
				canvas.height = newHeight;
				
				ctx.drawImage(image, 0, 0, newWidth, newHeight);
				
				try {
					await companyService.updateLogo(canvas.toDataURL())
					setLogo(companyService.selectedCompany.logo);
				}
				catch (e) {
					console.log(e.message);
				}
			};
		});
		fileReader.readAsDataURL(file);
	};
	
	const handleRemoveCustomLogo = async () => {
		try {
			await companyService.updateLogo("");
			setLogo(companyService.selectedCompany.logo);
		}
		catch (e) {
			console.log(e.message);
		}
	};
	
	return (
		<Box sx={{ width: "50%", margin: "auto" }}>
		{(companyService.selectedCompany.company_branding)?
				<Stack sx={{ width: "80%", textAlign: "center", margin: "auto" }}>
					<Typography variant="h6" sx={{  width: "100%", margin: "1em 0" }}>
						Company Branding
					</Typography>
					{logo &&
						<Box sx={{ width: "100%", margin: "0.25em 0" }}>
							<CardMedia
								component='img'
								src={logo}
								alt="custom company logo" 
								sx={{ width: "219px", margin: "auto" }}
							/>
						</Box>
					}
					<Box sx={{ width: "100%", margin: "0.25em 0" }}>
						<input
							accept="image/*"
							style={{ display: "none"}}
							id="upload-logo"
							multiple
							type="file"
							onChange={handleFileChange}
						/>
						<label htmlFor="upload-logo">
							<Button
								component="span"
								sx={{ width: "100%", textAlign: "center"}}
							>
								Upload Company Logo
							</Button>
						</label>
					</Box>
					{logo &&
						<Box sx={{ width: "100%", margin: "0.25em 0" }}>
							<Button
								onClick={handleRemoveCustomLogo}
								sx={{ width: "100%", textAlign: "center" }}
							>
								Remove Company Logo
							</Button>
						</Box>
					}
				</Stack>
		: <React.Fragment/> }
		</Box>
	);
};

export default AdminBranding;